import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core";
import { Colors, FONT_WEIGHT } from "../../helpers/theme";

const useStyles = makeStyles((theme) => ({
  item: {
    height: "280px",
  },
  emptyTitle: {
    fontSize: "1.625rem",
    color: "rgba(17, 48, 45, 1)",
    fontWeight: 700,
    margin: "3rem 0 1.5rem 0",
  },

  buyGainsButton: {
    backgroundColor: "transparent",
    color: "rgba(17, 48, 45, 1)",
    border: "1px solid rgba(17, 48, 45, 0.2)",
    height: "2.5rem",
    fontSize: "0.875rem",
    "&:hover": {
      backgroundColor: "rgba(17, 48, 45, 0.1)",
    },
  },

  exploreBtn: {
    height: "2.5rem",
    fontSize: "0.875rem",
    marginRight:"0.75rem",
  },

  projectspages: {
    "& .mainBox": {
      background: Colors.white,
      border: `1px solid ${alpha(Colors.darkWhite, 0.1)}`,
      boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.04)}`,
      borderRadius: "15px 15px 0px 0px",
    },
    "& .myportfolio": {
      "& .MuiTypography-h4": {
        fontSize: "16px",
      },
    },
    "& .livetimer": {
      width: "250px",
    },
    "& .launchtimer": {
      width: "250px",
    },
    "& .kyc_error": {
      color: "#E23636",
      fontSize: "10px",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginLeft: "15px",
    },
    "& .kyc_warning": {
      color: " #FFB818",
      fontSize: "10px",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginLeft: "15px",
    },

    "& h2": {
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.body1.fontSize,
        "& span": {
          fontSize: theme.typography.body1.fontSize,
        },
      },
    },

    "& .boxItem": {
      color: Colors.greySlate,
    },
    "& .contentBox": {
      background: Colors.white,
      border: `1px solid ${alpha(Colors.black, 0.1)}`,
      boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.04)}`,
      "&:focus, &:hover, &$active": {
        backgroundColor: "#6b82990a",
      },
    },
    "& .projectLogo": {
      width: "32px",
      height: "32px",
      borderRadius: "50px",
      verticalAlign: "middle",
      objectFit: "cover",
      marginRight: theme.spacing(2),
    },
    "& .m-left": {
      marginLeft: theme.spacing(7),
    },
    "& .MuiButton-label": {
      fontSize: "12px",
    },

    "& .mobielViewMain": {
      //mobile part style
      background: Colors.white,
      border: `1px solid ${alpha(Colors.darkWhite, 0.1)}`,
      boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.04)}`,

      borderRadius: "15px 15px 15px 15px",
    },
    "& .mobileContent": {
      background: ` ${alpha(Colors.aliceblue, 0.4)}`,
      borderRadius: " 6px",
    },

    "& .textColor": {
      color: Colors.greySlate,
    },
    "& .mobile-btn-width": {
      width: "50%",
      "&:first-child": {
        marginRight: "12px",
      },
    },
    "& .loadingBtn": {
      backgroundColor: ` ${alpha(Colors.loadingBlue, 0.2)}`,
      color: Colors.black,
      fontWeight: FONT_WEIGHT.bold,
      border: "0px",
    },
    "& .m-class": {
      marginRight: "5px",
    },
  },

  portfoliohead: {
    "& .MuiTableBody-root": {
      display: "block",
    },
    "& .MuiTableRow-root": {
      borderBottom: "1px solid rgba(76, 100, 97, 0.1)",
      verticalAlign: "baseline",
      width: "100%",
      display: "inherit",
      padding: "0px",
    },
    "& .MuiTypography-body1": {
      color: Colors.greySlate,
    },
    "& .MuiTableCell-root": {
      "&:first-child": {
        width: "15%",
      },
      "&:nth-child(2)": {
        width: "10%",
      },
      "&:nth-child(3)": {
        width: "10%",
      },
      "&:nth-child(4)": {
        width: "10%",
      },
      "&:nth-child(5)": {
        width: "8%",
      },
      "&:nth-child(6)": {
        width: "15%",
      },
      "&:nth-child(7)": {
        width: "10%",
      },
      "&:nth-child(8)": {
        width: "4%",
      },
      "&:nth-child(9)": {
        width: "18%",
      },
    },
  },
  walletsHead: {
    "& .MuiTableBody-root": {
      display: "flex",
    },
    "& .MuiTableRow-root": {
      borderBottom: "1px solid rgba(76, 100, 97, 0.1)",
      verticalAlign: "baseline",
      width: "100%",
      display: "inherit",
      padding: "0px",
    },
    "& .MuiTypography-body1": {
      color: Colors.greySlate,
    },
    "& .MuiTableCell-root": {
      "&:first-child": {
        width: "25%",
      },
      "&:nth-child(2)": {
        width: "60%",
      },
      "&:nth-child(3)": {
        width: "15%",
      },
    },
  },
  walletRow: {
    overflow: "hidden",
    "& .MuiTableCell-root": {
      "&:first-child": {
        width: "25%",
      },
      "&:nth-child(2)": {
        width: "60%",
      },
      "&:nth-child(3)": {
        width: "15%",
      },
    },
  },
  firsttable: {
    "&  .MuiTableRow-root": {
      width: "100%",
      boxShadow: "none",
      minHeight: "80px",
    },
  },
}));

export default useStyles;
